import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import { Field } from 'src/components';

const AddDialog = ({
  open,
  onClose,
  onSubmit,
  fields = [],
  source_key = ''
}) => {
  const [rowData, setRowData] = useState({});
  // Update rowData when a field changes
  const handleChangeField = (fieldKey, event) => {
    const value = event?.target?.value ?? event;
    setRowData(prev => ({
      ...prev,
      [fieldKey]: value
    }));
  };
  const handleSubmit = () => {
    // Build row in expected structure
    const newRow = {
      key: source_key || crypto.randomUUID(), // fallback unique key
      value: {}, // empty initially
      ...rowData // row keys like id2, id3, etc
    };
    onSubmit(newRow);

    setRowData({}); // reset form
    onClose();
  };
  useEffect(() => {
    setRowData({});
  }, [open]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h5">Add Row</Typography>
      </DialogTitle>

      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2}>
          {fields.map((field, index) => (
            <Field
              data={field}
              onChangeField={event => handleChangeField(field.field, event)}
            />
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDialog;
